let JointConsultation = [
  {
    path: '/JointConsultation_landing',
    name: '联合会诊',
    component: () => import('@/pages/JointConsultation/JointConsultation_landing')
  },
  {
    path: '/JointConsultation_landing_new',
    name: '联合会诊',
    component: () => import('@/pages/JointConsultation/JointConsultation_landing_new')
  },
  {
    path: '/JointConsultation_more_data',
    name: '补充资料',
    component: () => import('@/pages/JointConsultation/JointConsultation_more_data')
    // component: () => import('@/pages/JointConsultation/JointConsultation_more_data_new')
  },
  {
    path: '/JointConsultation_more_data_new',
    name: '补充资料',
    component: () => import('@/pages/JointConsultation/JointConsultation_more_data_new')
    // component: () => import('@/pages/JointConsultation/JointConsultation_more_data_new')
  },
  {
    path: '/JointConsultation_choose_disease_new',
    name: '选择病种',
    component: () => import('@/pages/JointConsultation/JointConsultation_choose_disease_new')
  },
  {
    path: '/JointConsultation_choose_disease',
    name: '选择病种',
    component: () => import('@/pages/JointConsultation/JointConsultation_choose_disease')
  },
  {
    path: '/JointConsultation_disease_info',
    name: '详情',
    component: () => import('@/pages/JointConsultation/JointConsultation_disease_info')
  },
  {
    path: '/JointConsultation_disease_info_new',
    name: '详情',
    component: () => import('@/pages/JointConsultation/JointConsultation_disease_info_new')
  },
  {
    path: '/JointConsultation_disease_info_second',
    name: '病种详情',
    component: () => import('@/pages/JointConsultation/JointConsultation_disease_info_second')
  },
  {
    path: '/JointConsultation_active',
    name: '特需门诊',
    component: () => import('@/pages/JointConsultation/JointConsultation_active')
  },
  {
    path: '/JointConsultation_yananvip',
    name: '特需门诊',
    component: () => import('@/pages/JointConsultation/JointConsultation_yananvip')
  }
]

export default JointConsultation
